import { render, staticRenderFns } from "./ShippingAdjustmentsModal.vue?vue&type=template&id=27ed5ffc"
import script from "./ShippingAdjustmentsModal.vue?vue&type=script&lang=js"
export * from "./ShippingAdjustmentsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports